import { render } from "./StatsBuilderCol.vue?vue&type=template&id=e24df86e"
import script from "./StatsBuilderCol.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderCol.vue?vue&type=script&lang=ts"

import "./StatsBuilderCol.vue?vue&type=style&index=0&id=e24df86e&lang=scss"
script.render = render

export default script